import { t as __exportAll } from "./rolldown-runtime-D7D4PA-g.js";
import { t as normalizeParams } from "./executor-DSji1iQ0.js";
import { t as createExecutorServer } from "./executor-server-CzLw7bBK.js";
import { BaseSearchIndexer, DEFAULT_ENTITY_PAGE_LIMIT, SEARCH_FETCH_LIMIT, SEARCH_PRESENTATION_LIMIT, buildEntityPageFromOverfetch, buildFileItems, buildJournalItems, buildMeetingItems, buildMessageItems, buildThreadItems, defineIndexableSource, getMeetingSearchDocIds, isRoutineRunThread, normalizeSearchQuery, rankSearchItems, readDeviceId, resolvePageLimit, tokenizeForSearchIndex } from "@littlebird/sdk";
import { and, asc, desc, eq, gt, inArray, isNotNull, isNull, lt, ne, or, sql } from "drizzle-orm";
import { drizzle } from "drizzle-orm/sqlite-proxy";
import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import { DISK_FULL_MESSAGE_PATTERNS, SENTRY_SUPPRESSION_REASONS, SuppressedError, errorMatchesAnyPattern } from "@littlebird/logger/error";
//#region src/migrations.generated.ts
const journal = {
	"version": "7",
	"dialect": "sqlite",
	"entries": [
		{
			"idx": 0,
			"version": "6",
			"when": 1787937588150,
			"tag": "0000_init",
			"breakpoints": true
		},
		{
			"idx": 1,
			"version": "6",
			"when": 1787937597556,
			"tag": "0001_search_fts",
			"breakpoints": true
		},
		{
			"idx": 2,
			"version": "6",
			"when": 1787996712794,
			"tag": "0002_contentless_search",
			"breakpoints": true
		},
		{
			"idx": 3,
			"version": "6",
			"when": 1788003973690,
			"tag": "0003_relational_indexes",
			"breakpoints": true
		},
		{
			"idx": 4,
			"version": "6",
			"when": 1788010863290,
			"tag": "0004_title_trigram",
			"breakpoints": true
		},
		{
			"idx": 5,
			"version": "6",
			"when": 1788492381789,
			"tag": "0005_colossal_ben_grimm",
			"breakpoints": true
		},
		{
			"idx": 6,
			"version": "6",
			"when": 1791973926117,
			"tag": "0006_meeting_sort_at_event_start",
			"breakpoints": true
		},
		{
			"idx": 7,
			"version": "6",
			"when": 1792726359857,
			"tag": "0007_action_card_source_meeting_id",
			"breakpoints": true
		}
	]
};
const migrations = {
	"m0000": "CREATE TABLE `action_cards` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `action_cards_updated_at_id_idx` ON `action_cards` (`updated_at`,`id`);--> statement-breakpoint\nCREATE TABLE `arenas` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `arenas_updated_at_id_idx` ON `arenas` (`updated_at`,`id`);--> statement-breakpoint\nCREATE TABLE `calendar_events` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `calendar_events_updated_at_id_idx` ON `calendar_events` (`updated_at`,`id`);--> statement-breakpoint\nCREATE TABLE `files` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `files_updated_at_id_idx` ON `files` (`updated_at`,`id`);--> statement-breakpoint\nCREATE TABLE `journals` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `journals_updated_at_id_idx` ON `journals` (`updated_at`,`id`);--> statement-breakpoint\nCREATE TABLE `mcp_client_grants` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `mcp_client_grants_updated_at_id_idx` ON `mcp_client_grants` (`updated_at`,`id`);--> statement-breakpoint\nCREATE TABLE `meetings` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL,\n	`sort_at` text GENERATED ALWAYS AS (coalesce(json_extract(data, '$.lastTranscribedAt'), json_extract(data, '$.createdAt'))) VIRTUAL,\n	`project_id` text GENERATED ALWAYS AS (json_extract(data, '$.projectId')) VIRTUAL,\n	`event_id` text GENERATED ALWAYS AS (json_extract(data, '$.eventId')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `meetings_updated_at_id_idx` ON `meetings` (`updated_at`,`id`);--> statement-breakpoint\nCREATE INDEX `meetings_sort_at_id_idx` ON `meetings` (`sort_at`,`id`);--> statement-breakpoint\nCREATE INDEX `meetings_event_id_idx` ON `meetings` (`event_id`);--> statement-breakpoint\nCREATE TABLE `messages` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL,\n	`thread_id` text GENERATED ALWAYS AS (json_extract(data, '$.threadId')) VIRTUAL,\n	`role` text GENERATED ALWAYS AS (json_extract(data, '$.role')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `messages_updated_at_id_idx` ON `messages` (`updated_at`,`id`);--> statement-breakpoint\nCREATE INDEX `messages_thread_created_at_id_idx` ON `messages` (`thread_id`,`created_at`,`id`);--> statement-breakpoint\nCREATE TABLE `_meta` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL\n);\n--> statement-breakpoint\nCREATE TABLE `_partial_indexes` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL,\n	`table_name` text GENERATED ALWAYS AS (json_extract(data, '$.table')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `partial_indexes_table_idx` ON `_partial_indexes` (`table_name`);--> statement-breakpoint\nCREATE TABLE `projects` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `projects_updated_at_id_idx` ON `projects` (`updated_at`,`id`);--> statement-breakpoint\nCREATE TABLE `_sync_actions` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `_sync_actions_updated_at_id_idx` ON `_sync_actions` (`updated_at`,`id`);--> statement-breakpoint\nCREATE TABLE `threads` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL,\n	`starred` integer GENERATED ALWAYS AS (json_extract(data, '$.starred')) VIRTUAL,\n	`archived` integer GENERATED ALWAYS AS (json_extract(data, '$.archived')) VIRTUAL,\n	`synced` integer GENERATED ALWAYS AS (json_extract(data, '$.synced')) VIRTUAL,\n	`project_id` text GENERATED ALWAYS AS (json_extract(data, '$.projectId')) VIRTUAL,\n	`origin` text GENERATED ALWAYS AS (json_extract(data, '$.origin')) VIRTUAL,\n	`meeting_id` text GENERATED ALWAYS AS (json_extract(data, '$.meetingId')) VIRTUAL,\n	`report_template_id` integer GENERATED ALWAYS AS (json_extract(data, '$.reportTemplateId')) VIRTUAL,\n	`title` text GENERATED ALWAYS AS (json_extract(data, '$.title')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `threads_updated_at_id_idx` ON `threads` (`updated_at`,`id`);--> statement-breakpoint\nCREATE INDEX `threads_starred_updated_at_id_idx` ON `threads` (`starred`,`updated_at`,`id`);--> statement-breakpoint\nCREATE INDEX `threads_project_id_idx` ON `threads` (`project_id`);--> statement-breakpoint\nCREATE TABLE `_transactions` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `_transactions_updated_at_id_idx` ON `_transactions` (`updated_at`,`id`);--> statement-breakpoint\nCREATE TABLE `user_configs` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `user_configs_updated_at_id_idx` ON `user_configs` (`updated_at`,`id`);",
	"m0001": "CREATE VIRTUAL TABLE search_fts USING fts5(\n  id UNINDEXED,\n  type UNINDEXED,\n  threadId UNINDEXED,\n  title,\n  content,\n  updatedAt UNINDEXED,\n  tokenize = 'porter unicode61'\n);\n",
	"m0002": "DROP TABLE IF EXISTS search_fts;\n--> statement-breakpoint\nCREATE VIRTUAL TABLE search_fts USING fts5(\n  id UNINDEXED,\n  type UNINDEXED,\n  threadId UNINDEXED,\n  reportTemplateId UNINDEXED,\n  updatedAt UNINDEXED,\n  title,\n  content,\n  content='',\n  contentless_delete=1,\n  contentless_unindexed=1,\n  tokenize='porter unicode61'\n);\n--> statement-breakpoint\nINSERT INTO search_fts(search_fts, rank) VALUES('rank', 'bm25(0.0, 0.0, 0.0, 0.0, 0.0, 10.0, 1.0)');\n--> statement-breakpoint\nCREATE TABLE search_docs (\n  id TEXT PRIMARY KEY\n);\n--> statement-breakpoint\nCREATE TABLE search_note_text (\n  id TEXT PRIMARY KEY,\n  text TEXT NOT NULL\n);\n",
	"m0003": "ALTER TABLE `action_cards` ADD `chat_id` text GENERATED ALWAYS AS (json_extract(data, '$.chatId')) VIRTUAL;--> statement-breakpoint\nCREATE INDEX `action_cards_chat_id_idx` ON `action_cards` (`chat_id`);--> statement-breakpoint\nALTER TABLE `_sync_actions` ADD `sync_id` integer GENERATED ALWAYS AS (json_extract(data, '$.syncId')) VIRTUAL;--> statement-breakpoint\nCREATE INDEX `sync_actions_sync_id_idx` ON `_sync_actions` (`sync_id`);--> statement-breakpoint\nCREATE INDEX `meetings_project_id_idx` ON `meetings` (`project_id`);--> statement-breakpoint\nCREATE INDEX `threads_meeting_id_idx` ON `threads` (`meeting_id`);",
	"m0004": "CREATE VIRTUAL TABLE search_title_trigram USING fts5(\n  id UNINDEXED,\n  type UNINDEXED,\n  threadId UNINDEXED,\n  reportTemplateId UNINDEXED,\n  updatedAt UNINDEXED,\n  title,\n  content='',\n  contentless_delete=1,\n  contentless_unindexed=1,\n  tokenize='trigram'\n);\n",
	"m0005": "CREATE TABLE `agents` (\n	`id` text PRIMARY KEY NOT NULL,\n	`data` text NOT NULL,\n	`created_at` text GENERATED ALWAYS AS (json_extract(data, '$.createdAt')) VIRTUAL,\n	`updated_at` text GENERATED ALWAYS AS (json_extract(data, '$.updatedAt')) VIRTUAL,\n	`deleted_at` text GENERATED ALWAYS AS (json_extract(data, '$.deletedAt')) VIRTUAL\n);\n--> statement-breakpoint\nCREATE INDEX `agents_updated_at_id_idx` ON `agents` (`updated_at`,`id`);--> statement-breakpoint\nALTER TABLE `threads` ADD `agent_id` text GENERATED ALWAYS AS (json_extract(data, '$.agentId')) VIRTUAL;--> statement-breakpoint\nCREATE INDEX `threads_agent_id_idx` ON `threads` (`agent_id`);",
	"m0006": "DROP INDEX `meetings_sort_at_id_idx`;--> statement-breakpoint\nALTER TABLE `meetings` DROP COLUMN `sort_at`;--> statement-breakpoint\nALTER TABLE `meetings` ADD `sort_at` text GENERATED ALWAYS AS (coalesce(json_extract(data, '$.lastTranscribedAt'), json_extract(data, '$.eventStartAt'), json_extract(data, '$.createdAt'))) VIRTUAL;--> statement-breakpoint\nCREATE INDEX `meetings_sort_at_id_idx` ON `meetings` (`sort_at`,`id`);\n",
	"m0007": "ALTER TABLE `action_cards` ADD `source_meeting_id` text GENERATED ALWAYS AS (json_extract(data, '$.sourceMeetingId')) VIRTUAL;--> statement-breakpoint\nCREATE INDEX `action_cards_source_meeting_id_idx` ON `action_cards` (`source_meeting_id`);"
};
//#endregion
//#region src/schema.ts
var schema_exports = /* @__PURE__ */ __exportAll({
	actionCards: () => actionCards,
	agents: () => agents,
	arenas: () => arenas,
	calendarEvents: () => calendarEvents,
	files: () => files,
	journals: () => journals,
	mcpClientGrants: () => mcpClientGrants,
	meetings: () => meetings,
	messages: () => messages,
	meta: () => meta,
	partialIndexes: () => partialIndexes,
	projects: () => projects,
	syncActions: () => syncActions,
	threads: () => threads,
	transactions: () => transactions,
	userConfigs: () => userConfigs
});
const fromData = (path) => sql`json_extract(data, ${sql.raw(`'$.${path}'`)})`;
const virtual = { mode: "virtual" };
const entityColumns = {
	id: text("id").primaryKey(),
	data: text("data", { mode: "json" }).$type().notNull(),
	createdAt: text("created_at").generatedAlwaysAs(fromData("createdAt"), virtual),
	updatedAt: text("updated_at").generatedAlwaysAs(fromData("updatedAt"), virtual),
	deletedAt: text("deleted_at").generatedAlwaysAs(fromData("deletedAt"), virtual)
};
const entityIndexes = (name, table) => [index(`${name}_updated_at_id_idx`).on(table.updatedAt, table.id)];
const threads = sqliteTable("threads", {
	...entityColumns,
	starred: integer("starred", { mode: "boolean" }).generatedAlwaysAs(fromData("starred"), virtual),
	archived: integer("archived", { mode: "boolean" }).generatedAlwaysAs(fromData("archived"), virtual),
	synced: integer("synced", { mode: "boolean" }).generatedAlwaysAs(fromData("synced"), virtual),
	projectId: text("project_id").generatedAlwaysAs(fromData("projectId"), virtual),
	origin: text("origin").generatedAlwaysAs(fromData("origin"), virtual),
	meetingId: text("meeting_id").generatedAlwaysAs(fromData("meetingId"), virtual),
	reportTemplateId: integer("report_template_id").generatedAlwaysAs(fromData("reportTemplateId"), virtual),
	title: text("title").generatedAlwaysAs(fromData("title"), virtual),
	agentId: text("agent_id").generatedAlwaysAs(fromData("agentId"), virtual)
}, (table) => [
	...entityIndexes("threads", table),
	index("threads_starred_updated_at_id_idx").on(table.starred, table.updatedAt, table.id),
	index("threads_project_id_idx").on(table.projectId),
	index("threads_meeting_id_idx").on(table.meetingId),
	index("threads_agent_id_idx").on(table.agentId)
]);
const messages = sqliteTable("messages", {
	...entityColumns,
	threadId: text("thread_id").generatedAlwaysAs(fromData("threadId"), virtual),
	role: text("role").generatedAlwaysAs(fromData("role"), virtual)
}, (table) => [...entityIndexes("messages", table), index("messages_thread_created_at_id_idx").on(table.threadId, table.createdAt, table.id)]);
const meetings = sqliteTable("meetings", {
	...entityColumns,
	sortAt: text("sort_at").generatedAlwaysAs(sql`coalesce(json_extract(data, '$.lastTranscribedAt'), json_extract(data, '$.eventStartAt'), json_extract(data, '$.createdAt'))`, virtual),
	projectId: text("project_id").generatedAlwaysAs(fromData("projectId"), virtual),
	eventId: text("event_id").generatedAlwaysAs(fromData("eventId"), virtual)
}, (table) => [
	...entityIndexes("meetings", table),
	index("meetings_sort_at_id_idx").on(table.sortAt, table.id),
	index("meetings_event_id_idx").on(table.eventId),
	index("meetings_project_id_idx").on(table.projectId)
]);
function plainEntityTable(name) {
	return sqliteTable(name, entityColumns, (table) => entityIndexes(name, table));
}
const files = plainEntityTable("files");
const journals = plainEntityTable("journals");
const arenas = plainEntityTable("arenas");
const projects = plainEntityTable("projects");
const agents = plainEntityTable("agents");
const mcpClientGrants = plainEntityTable("mcp_client_grants");
const userConfigs = plainEntityTable("user_configs");
const calendarEvents = plainEntityTable("calendar_events");
const actionCards = sqliteTable("action_cards", {
	...entityColumns,
	chatId: text("chat_id").generatedAlwaysAs(fromData("chatId"), virtual),
	sourceMeetingId: text("source_meeting_id").generatedAlwaysAs(fromData("sourceMeetingId"), virtual)
}, (table) => [
	...entityIndexes("action_cards", table),
	index("action_cards_chat_id_idx").on(table.chatId),
	index("action_cards_source_meeting_id_idx").on(table.sourceMeetingId)
]);
const partialIndexes = sqliteTable("_partial_indexes", {
	...entityColumns,
	table: text("table_name").generatedAlwaysAs(fromData("table"), virtual)
}, (table) => [index("partial_indexes_table_idx").on(table.table)]);
const transactions = plainEntityTable("_transactions");
const syncActions = sqliteTable("_sync_actions", {
	...entityColumns,
	syncId: integer("sync_id").generatedAlwaysAs(fromData("syncId"), virtual)
}, (table) => [...entityIndexes("_sync_actions", table), index("sync_actions_sync_id_idx").on(table.syncId)]);
const meta = sqliteTable("_meta", {
	id: text("id").primaryKey(),
	data: text("data", { mode: "json" }).$type().notNull()
});
//#endregion
//#region src/local-db.ts
const MIGRATIONS_TABLE = "__local_db_migrations";
const LOCAL_DB_TABLES = {
	threads,
	messages,
	files,
	journals,
	arenas,
	meetings,
	projects,
	agents,
	mcpClientGrants,
	userConfigs,
	calendarEvents,
	actionCards,
	_partialIndexes: partialIndexes,
	_transactions: transactions,
	_syncActions: syncActions
};
function bundledMigrations() {
	return journal.entries.map((entry) => ({
		sql: migrations[`m${String(entry.idx).padStart(4, "0")}`].split("--> statement-breakpoint"),
		bps: entry.breakpoints,
		folderMillis: entry.when,
		hash: entry.tag
	}));
}
async function tableNames(db) {
	const rows = await db.values(sql`SELECT name FROM sqlite_master WHERE type = 'table'`);
	return new Set(rows.map(([name]) => name));
}
async function newestThreadUpdate(db) {
	try {
		const [[newest]] = await db.values(sql`SELECT max(updated_at) FROM threads`);
		return newest ?? "none";
	} catch {
		return "unknown";
	}
}
function createDatabase(executor) {
	return drizzle(async (sqlText, params, method) => {
		const { rows } = await executor.execute({
			sql: sqlText,
			params: normalizeParams(params),
			method
		});
		return { rows };
	}, { schema: schema_exports });
}
async function runTransaction(db, fn) {
	try {
		await db.run(sql`begin`);
	} catch (error) {
		await db.run(sql`rollback`).catch(() => void 0);
		throw error;
	}
	try {
		const result = await fn();
		await db.run(sql`commit`);
		return result;
	} catch (error) {
		await db.run(sql`rollback`);
		throw error;
	}
}
async function openLocalDb(executor, logger, getDeviceId) {
	const db = createDatabase(executor);
	const names = await tableNames(db);
	const foreign = names.has("threads") && !names.has("__local_db_migrations");
	if (foreign) {
		logger.warn("local-db: found tables without migration bookkeeping, resetting database", {
			context: "local_db_foreign_schema_reset",
			deviceId: await readDeviceId(getDeviceId),
			tables: [...names].sort().join(","),
			newestThreadUpdatedAt: await newestThreadUpdate(db)
		});
		await executor.reset();
	}
	await db.dialect.migrate(bundledMigrations(), db.session, { migrationsTable: MIGRATIONS_TABLE });
	let transactionChain = Promise.resolve();
	let active = false;
	function withOwnTransaction(fn) {
		const next = transactionChain.then(() => runTransaction(db, fn));
		transactionChain = next.catch(() => void 0);
		return next;
	}
	return {
		db,
		executor,
		unrecognisedReset: foreign,
		withTransaction(fn) {
			if (active) return fn();
			return withOwnTransaction(async () => {
				active = true;
				try {
					return await fn();
				} finally {
					active = false;
				}
			});
		},
		withOwnTransaction
	};
}
//#endregion
//#region src/dates.ts
const DATE_FIELDS = /* @__PURE__ */ new Set([
	"createdAt",
	"updatedAt",
	"deletedAt",
	"date",
	"endedAt",
	"firstChunkTimestamp",
	"lastMessageAt",
	"lastTranscribedAt",
	"eventStartAt",
	"firstTranscriptAt",
	"transcriptDeletedAt",
	"sortAt",
	"authorizedAt",
	"resolvedAt",
	"dismissedAt",
	"viewedAt",
	"pinnedAt",
	"archivedAt",
	"snoozedUntil",
	"expiresAt",
	"dueAt"
]);
function deserializeDates(record) {
	const result = { ...record };
	for (const key of DATE_FIELDS) {
		const value = result[key];
		if (typeof value !== "string") continue;
		const parsed = Date.parse(value);
		if (!Number.isNaN(parsed)) result[key] = new Date(parsed);
	}
	return result;
}
function deserializeDatesInArray(records) {
	return records.map(deserializeDates);
}
//#endregion
//#region src/entity-queries.ts
const ID_CHUNK = 500;
const LATEST_PAGE_CHUNK = 100;
function chunked(items) {
	const chunks = [];
	for (let i = 0; i < items.length; i += ID_CHUNK) chunks.push(items.slice(i, i + ID_CHUNK));
	return chunks;
}
const limitOf = (options) => resolvePageLimit(options, DEFAULT_ENTITY_PAGE_LIMIT);
const cursorValue = (cursor) => cursor.value == null ? "" : String(cursor.value);
/** `(sortColumn, id) < (cursor.value, cursor.id)` for DESC keyset paging */
function beforeCursor(sortColumn, idColumn, cursor) {
	const value = cursorValue(cursor);
	return or(lt(sortColumn, value), and(eq(sortColumn, value), lt(idColumn, cursor.id)));
}
async function page(db, table, where, sortColumn, sortKey, options) {
	const limit = limitOf(options);
	const records = deserializeDatesInArray((await db.select({ data: table.data }).from(table).where(where).orderBy(desc(sortColumn), desc(table.id)).limit(limit + 1)).map((row) => row.data));
	return buildEntityPageFromOverfetch(records, limit, (record) => {
		const record_ = record;
		const raw = sortKey === "sortAt" ? record_.lastTranscribedAt ?? record_.eventStartAt ?? record_.createdAt : record_[sortKey];
		return raw instanceof Date ? raw.toISOString() : raw ?? null;
	});
}
function baseQueries(db, table) {
	const live = isNull(table.deletedAt);
	return {
		listPage: (options) => page(db, table, live, table.updatedAt, "updatedAt", options),
		listPageAfter: (cursor, options) => page(db, table, and(live, beforeCursor(table.updatedAt, table.id, cursor)), table.updatedAt, "updatedAt", options),
		async getByIds(ids) {
			if (ids.length === 0) return [];
			return deserializeDatesInArray((await db.select({ data: table.data }).from(table).where(inArray(table.id, ids))).map((row) => row.data));
		},
		async getById(id) {
			const rows = await db.select({ data: table.data }).from(table).where(eq(table.id, id)).limit(1);
			return rows[0] ? deserializeDates(rows[0].data) : void 0;
		},
		async existingIds(ids) {
			const found = [];
			for (const chunk of chunked(ids)) {
				const rows = await db.select({ id: table.id }).from(table).where(inArray(table.id, chunk));
				found.push(...rows.map((row) => row.id));
			}
			return found;
		},
		async listIdsAfter(afterId, limit) {
			return (await db.select({ id: table.id }).from(table).where(afterId === void 0 ? live : and(live, gt(table.id, afterId))).orderBy(asc(table.id)).limit(limit)).map((row) => row.id);
		}
	};
}
function projectMemberQueries(db, table, countWhere) {
	return {
		async countByProject() {
			const rows = await db.select({
				projectId: table.projectId,
				count: sql`count(*)`
			}).from(table).where(and(countWhere, isNotNull(table.projectId))).groupBy(table.projectId);
			return Object.fromEntries(rows.map((row) => [row.projectId, Number(row.count)]));
		},
		async clearProjectId(projectId) {
			return (await db.update(table).set({ data: sql`json_set(data, '$.projectId', NULL)` }).where(eq(table.projectId, projectId)).returning({ id: table.id })).map((row) => row.id);
		},
		async restoreProjectId(ids, projectId) {
			for (const chunk of chunked(ids)) await db.update(table).set({ data: sql`json_set(data, '$.projectId', ${projectId})` }).where(and(inArray(table.id, chunk), isNull(table.projectId)));
		}
	};
}
/** SQL form of the desktop `matchesThreadQuery` predicate */
function threadWhere(starred, options) {
	const t = threads;
	const clauses = [
		isNull(t.deletedAt),
		isNull(t.reportTemplateId),
		starred ? eq(t.starred, true) : sql`${t.starred} IS NOT 1`
	];
	if (options?.origin) clauses.push(eq(t.origin, options.origin));
	if (options?.includeMessagingChannelChats === false) clauses.push(sql`json_extract(${t.data}, '$.isMessagingChannel') IS NOT 1`);
	const filter = options?.filter;
	if (filter && typeof filter !== "string" && filter.kind === "agent") return and(isNull(t.deletedAt), starred ? eq(t.starred, true) : sql`${t.starred} IS NOT 1`, eq(t.agentId, filter.agentId));
	clauses.push(isNull(t.agentId));
	if (!filter) return and(...clauses);
	if (typeof filter !== "string") {
		clauses.push(eq(t.projectId, filter.projectId));
		return and(...clauses);
	}
	clauses.push(or(isNull(t.synced), eq(t.synced, true)), or(isNull(t.title), ne(t.title, "temp")));
	if (filter === "archived") {
		clauses.push(eq(t.archived, true));
		return and(...clauses);
	}
	clauses.push(or(isNull(t.archived), eq(t.archived, false)));
	if (filter === "favorites") clauses.push(eq(t.starred, true));
	if (filter === "in-project") clauses.push(isNotNull(t.projectId));
	if (filter === "no-project") clauses.push(isNull(t.projectId));
	if (filter === "from-meeting") clauses.push(isNotNull(t.meetingId));
	return and(...clauses);
}
function threadQueries(db) {
	const t = threads;
	const list = (starred, cursor, options) => page(db, t, cursor ? and(threadWhere(starred, options), beforeCursor(t.updatedAt, t.id, cursor)) : threadWhere(starred, options), t.updatedAt, "updatedAt", options);
	return {
		...baseQueries(db, t),
		...projectMemberQueries(db, t, and(isNull(t.deletedAt), isNull(t.reportTemplateId))),
		async getByMeetingId(meetingId) {
			const rows = await db.select({ data: t.data }).from(t).where(and(isNull(t.deletedAt), eq(t.meetingId, meetingId))).orderBy(desc(t.synced), desc(t.updatedAt), desc(t.id)).limit(1);
			return rows[0] ? deserializeDates(rows[0].data) : void 0;
		},
		listPinned: (options) => list(true, void 0, options),
		listPinnedAfter: (cursor, options) => list(true, cursor, options),
		listRecent: (options) => list(false, void 0, options),
		listRecentAfter: (cursor, options) => list(false, cursor, options)
	};
}
function messageQueries(db) {
	const m = messages;
	return {
		...baseQueries(db, m),
		listLatestForThread: (threadId, options) => page(db, m, and(isNull(m.deletedAt), eq(m.threadId, threadId)), m.createdAt, "createdAt", options),
		listOlderForThread: (threadId, cursor, options) => page(db, m, and(isNull(m.deletedAt), eq(m.threadId, threadId), beforeCursor(m.createdAt, m.id, cursor)), m.createdAt, "createdAt", options),
		async getLastUserMessageForThread(threadId) {
			const rows = await db.select({ data: m.data }).from(m).where(and(isNull(m.deletedAt), eq(m.threadId, threadId), eq(m.role, "user"))).orderBy(desc(m.createdAt), desc(m.id)).limit(1);
			return rows[0] ? deserializeDates(rows[0].data) : void 0;
		},
		async deleteManyByThread(threadId) {
			await db.delete(m).where(eq(m.threadId, threadId));
		},
		async listIdsByThreads(threadIds) {
			const ids = [];
			for (const chunk of chunked(threadIds)) {
				const rows = await db.select({ id: m.id }).from(m).where(inArray(m.threadId, chunk));
				ids.push(...rows.map((row) => row.id));
			}
			return ids;
		},
		listLatestForThreads: (threadIds, options) => latestPagesByThread(db, threadIds, options)
	};
}
async function latestPagesByThread(db, threadIds, options) {
	const limit = limitOf(options);
	const pages = /* @__PURE__ */ new Map();
	if (threadIds.length === 0) return pages;
	const byThread = /* @__PURE__ */ new Map();
	const uniqueIds = Array.from(new Set(threadIds));
	for (let i = 0; i < uniqueIds.length; i += LATEST_PAGE_CHUNK) {
		const chunk = uniqueIds.slice(i, i + LATEST_PAGE_CHUNK);
		const rows = await db.values(sql`
      SELECT thread_id, data FROM (${sql.join(chunk.map((id) => sql`SELECT * FROM (
            SELECT thread_id, data, created_at, id FROM messages
            WHERE thread_id = ${id} AND deleted_at IS NULL
            ORDER BY created_at DESC, id DESC LIMIT ${limit + 1}
          )`), sql` UNION ALL `)})
      ORDER BY thread_id, created_at DESC, id DESC
    `);
		for (const [threadId, data] of rows) {
			const record = deserializeDates(JSON.parse(data));
			const list = byThread.get(threadId) ?? [];
			list.push(record);
			byThread.set(threadId, list);
		}
	}
	for (const threadId of threadIds) pages.set(threadId, buildEntityPageFromOverfetch(byThread.get(threadId) ?? [], limit, (record) => {
		const value = record.createdAt;
		return value instanceof Date ? value.toISOString() : value ?? null;
	}));
	return pages;
}
function meetingWhere(options) {
	const mt = meetings;
	const filter = options?.filter;
	if (!filter || filter.kind === "all-meetings") return isNull(mt.deletedAt);
	if (filter.kind === "no-project") return and(isNull(mt.deletedAt), isNull(mt.projectId));
	return and(isNull(mt.deletedAt), eq(mt.projectId, filter.projectId));
}
const parseAttendees = (raw) => {
	if (!raw) return null;
	try {
		const attendees = JSON.parse(raw);
		return Array.isArray(attendees) ? attendees : null;
	} catch {
		return null;
	}
};
function meetingQueries(db) {
	const mt = meetings;
	return {
		...baseQueries(db, mt),
		...projectMemberQueries(db, mt, isNull(mt.deletedAt)),
		listBySortAt: (options) => page(db, mt, meetingWhere(options), mt.sortAt, "sortAt", options),
		listBySortAtAfter: (cursor, options) => page(db, mt, and(meetingWhere(options), beforeCursor(mt.sortAt, mt.id, cursor)), mt.sortAt, "sortAt", options),
		async getByEventId(eventId) {
			const rows = await db.select({ data: mt.data }).from(mt).where(and(isNull(mt.deletedAt), eq(mt.eventId, eventId))).orderBy(desc(mt.updatedAt), desc(mt.id)).limit(1);
			return rows[0] ? deserializeDates(rows[0].data) : void 0;
		},
		async listAttendeeSummaries() {
			return (await db.select({
				id: mt.id,
				name: sql`json_extract(${mt.data}, '$.name')`,
				eventId: mt.eventId,
				calendarSeriesId: sql`json_extract(${mt.data}, '$.calendarSeriesId')`,
				projectId: mt.projectId,
				sortAt: mt.sortAt,
				attendees: sql`json_extract(${mt.data}, '$.attendees')`
			}).from(mt).where(isNull(mt.deletedAt)).orderBy(desc(mt.sortAt), desc(mt.id))).map((row) => ({
				...row,
				attendees: parseAttendees(row.attendees)
			}));
		}
	};
}
const sqlValues = (values) => sql.join(values.map((value) => sql`${value}`), sql`, `);
const isIn = (column, values) => values.length > 0 ? sql`${column} IN (${sqlValues(values)})` : sql`0`;
const isNotIn = (column, values) => values.length > 0 ? sql`${column} NOT IN (${sqlValues(values)})` : sql`1`;
const historyRowsMatching = (query) => sql`
  FROM action_cards c
  LEFT JOIN threads t ON t.id = c.chat_id
  WHERE c.deleted_at IS NULL
    AND t.deleted_at IS NULL
    AND json_extract(c.data, '$.origin') IN ('chat', 'routine')
    AND (${isIn(sql`json_extract(c.data, '$.actionType')`, query.keptActionTypes)}
      OR (${isIn(sql`json_extract(c.data, '$.actionType')`, query.todoActionTypes)}
        AND json_extract(c.data, '$.content.kind') = 'todo'))
    AND ${isNotIn(sql`c.id`, query.excludeIds)}
    AND (c.chat_id IS NULL OR ${isNotIn(sql`c.chat_id`, query.excludeChatIds)})`;
const historyBucketMatching = (bucket) => bucket === "dismissed" ? sql`json_extract(c.data, '$.status') = 'dismissed'` : sql`json_extract(c.data, '$.status') IN ('completed', 'completed_externally')
        AND json_extract(c.data, '$.followUpRequestId') IS NULL`;
async function countActionCardHistory(db, query) {
	const [row] = await db.values(sql`SELECT
          SUM(CASE WHEN ${historyBucketMatching("dismissed")} THEN 1 ELSE 0 END),
          SUM(CASE WHEN ${historyBucketMatching("done")} THEN 1 ELSE 0 END)
        ${historyRowsMatching(query)}`);
	return {
		dismissed: row?.[0] ?? 0,
		done: row?.[1] ?? 0
	};
}
async function listActionCardHistoryPage(db, query, bucket, limit) {
	return (await db.values(sql`SELECT c.id,
               MAX(c.created_at, COALESCE(json_extract(c.data, '$.followUpRepliedAt'), '')) AS at
        ${historyRowsMatching(query)}
          AND ${historyBucketMatching(bucket)}
        ORDER BY at DESC, c.id ASC
        LIMIT ${limit}`)).map(([id, at]) => ({
		id,
		at
	}));
}
function actionCardQueries(db) {
	return {
		...baseQueries(db, actionCards),
		async listOpenIds() {
			return (await db.values(sql`SELECT id FROM action_cards
            WHERE deleted_at IS NULL
              AND (json_extract(data, '$.status') IN ('draft', 'failed', 'running')
                OR json_extract(data, '$.followUpRequestId') IS NOT NULL)`)).map(([id]) => id);
		},
		countHistory: (query) => countActionCardHistory(db, query),
		listHistoryPage: (query, bucket, limit) => listActionCardHistoryPage(db, query, bucket, limit),
		async listIdsByLocalIds(localIds) {
			if (localIds.length === 0) return [];
			return (await db.values(sql`SELECT id FROM action_cards
            WHERE deleted_at IS NULL
              AND json_extract(data, '$.localId') IN (${sql.join(localIds.map((localId) => sql`${localId}`), sql`, `)})`)).map(([id]) => id);
		}
	};
}
function syncActionQueries(db) {
	const sa = syncActions;
	return {
		async pruneBelow(syncId) {
			return (await db.delete(sa).where(lt(sa.syncId, syncId)).returning({ id: sa.id })).length;
		},
		async maxSyncId() {
			return (await db.values(sql`SELECT max(sync_id) FROM _sync_actions`))[0]?.[0] ?? void 0;
		},
		async hasSyncIds(syncIds) {
			const found = /* @__PURE__ */ new Set();
			for (const chunk of chunked(syncIds)) {
				const rows = await db.select({ syncId: sa.syncId }).from(sa).where(inArray(sa.syncId, chunk));
				for (const row of rows) found.add(Number(row.syncId));
			}
			return found;
		}
	};
}
function createEntityQueryModules(db) {
	return {
		threads: threadQueries(db),
		messages: messageQueries(db),
		meetings: meetingQueries(db),
		journals: baseQueries(db, journals),
		projects: baseQueries(db, projects),
		agents: baseQueries(db, agents),
		files: baseQueries(db, files),
		arenas: baseQueries(db, arenas),
		mcpClientGrants: baseQueries(db, mcpClientGrants),
		userConfigs: baseQueries(db, userConfigs),
		calendarEvents: baseQueries(db, calendarEvents),
		actionCards: actionCardQueries(db),
		_syncActions: syncActionQueries(db)
	};
}
//#endregion
//#region src/storage-adapter.ts
const BATCH_SIZE = 500;
const META_ID = "meta";
const BOOTSTRAP_PENDING_ID = "bootstrapPending";
const INDEXED_COLUMNS = {
	actionCards: {
		chatId: actionCards.chatId,
		sourceMeetingId: actionCards.sourceMeetingId
	},
	messages: { threadId: messages.threadId },
	_partialIndexes: { table: partialIndexes.table }
};
var DiskFullError = class extends SuppressedError {
	reason = SENTRY_SUPPRESSION_REASONS.deviceStorage;
	constructor(cause) {
		super("Device storage is full or unavailable; cannot complete DB operation", cause);
		this.name = "DiskFullError";
	}
};
var SqliteStorageAdapter = class {
	executor;
	logger;
	options;
	entities = {};
	initPromise = null;
	_localDb = null;
	bootstrapPending = false;
	metaUpdateChain = Promise.resolve();
	constructor(executor, logger, options = {}) {
		this.executor = executor;
		this.logger = logger;
		this.options = options;
	}
	get localDb() {
		if (!this._localDb) throw new Error("SqliteStorageAdapter used before init()");
		return this._localDb;
	}
	get fullBootstrapPending() {
		return this.bootstrapPending;
	}
	get unrecognisedReset() {
		return this._localDb?.unrecognisedReset ?? false;
	}
	init() {
		this.initPromise ??= (async () => {
			this._localDb = await openLocalDb(this.executor, this.logger, this.options.getDeviceId);
			this.entities = createEntityQueryModules(this._localDb.db);
			const rows = await this._localDb.db.select({ data: meta.data }).from(meta).where(eq(meta.id, BOOTSTRAP_PENDING_ID)).limit(1);
			this.bootstrapPending = rows[0]?.data?.pending === true;
		})().catch((error) => {
			this.initPromise = null;
			throw this.mapError(error);
		});
		return this.initPromise;
	}
	hasTable(_table) {
		return true;
	}
	async markBootstrapStarted() {
		await this.writeMetaRow(BOOTSTRAP_PENDING_ID, { pending: true });
		this.bootstrapPending = true;
	}
	async markBootstrapComplete() {
		await this.writeMetaRow(BOOTSTRAP_PENDING_ID, { pending: false });
		this.bootstrapPending = false;
	}
	async get(table, id) {
		const entity = this.entityTable(table);
		const rows = await this.run(() => this.db.select({ data: entity.data }).from(entity).where(eq(entity.id, id)).limit(1));
		return rows[0] ? deserializeDates(rows[0].data) : void 0;
	}
	async getAll(table) {
		const entity = this.entityTable(table);
		const rows = await this.run(() => this.db.select({ data: entity.data }).from(entity));
		return this.toRecords(rows);
	}
	async getManyByIndex(table, indexName, value) {
		const entity = this.entityTable(table);
		const column = this.indexedColumn(table, indexName);
		const rows = await this.run(() => this.db.select({ data: entity.data }).from(entity).where(eq(column, value)));
		return this.toRecords(rows);
	}
	async getAllAfter(table, since) {
		const entity = this.entityTable(table);
		const sinceIso = new Date(since).toISOString();
		const rows = await this.run(() => this.db.select({ data: entity.data }).from(entity).where(gt(entity.updatedAt, sinceIso)));
		return this.toRecords(rows);
	}
	async set(table, model) {
		await this.bulkSet(table, [model]);
	}
	async update(table, id, value) {
		const entity = this.entityTable(table);
		await this.run(() => this.localDb.withTransaction(async () => {
			const current = await this.get(table, id);
			if (!current) return;
			const merged = {
				...serializeRecord(current),
				...serializeRecord(value),
				id
			};
			await this.db.update(entity).set({ data: merged }).where(eq(entity.id, id));
		}));
	}
	async bulkSet(table, records) {
		if (records.length === 0) return;
		const entity = this.entityTable(table);
		const rows = records.map((record) => ({
			id: record.id,
			data: serializeRecord(record)
		}));
		await this.run(() => this.localDb.withTransaction(async () => {
			for (let i = 0; i < rows.length; i += BATCH_SIZE) await this.db.insert(entity).values(rows.slice(i, i + BATCH_SIZE)).onConflictDoUpdate({
				target: entity.id,
				set: { data: sql`excluded.data` }
			});
		}));
	}
	async deleteManyByIndex(table, indexName, value) {
		const entity = this.entityTable(table);
		const column = this.indexedColumn(table, indexName);
		await this.run(() => this.db.delete(entity).where(eq(column, value)));
	}
	async remove(table, id) {
		const entity = this.entityTable(table);
		await this.run(() => this.db.delete(entity).where(eq(entity.id, id)));
	}
	async bulkRemove(table, ids) {
		if (ids.length === 0) return;
		const entity = this.entityTable(table);
		const unique = [...new Set(ids)];
		await this.run(() => this.localDb.withTransaction(async () => {
			for (let i = 0; i < unique.length; i += BATCH_SIZE) await this.db.delete(entity).where(inArray(entity.id, unique.slice(i, i + BATCH_SIZE)));
		}));
	}
	async getMetaData() {
		return await this.readMetaRow(META_ID);
	}
	async updateMetaData(mutate, options) {
		await this.queueMetaWrite(async () => {
			const updated = mutate(await this.getMetaData());
			if (!updated) return;
			await this.writeMetaRow(META_ID, updated);
			if (options?.notifyCrossWindowEntitySync !== false) this.notifyCrossWindowSync();
		});
	}
	getMetaRow(id) {
		return this.readMetaRow(id);
	}
	setMetaRow(id, data) {
		return this.writeMetaRow(id, data);
	}
	notifyCrossWindowSync() {
		this.options.onCrossWindowSync?.();
	}
	/**
	* Account size cheap enough for the startup path. `page_count` reads the
	* header; the slice count is a covering-index scan of `_partial_indexes`,
	* one row per chat ever opened — measured under 3ms at 20k rows, where a
	* real account holds tens. `diagnostics()` counts every table instead,
	* including the FTS5 virtual ones.
	*/
	async sizeProbe() {
		await this.init();
		const [[pageCount = 0, pageSize = 0] = []] = await this.db.values(sql`SELECT page_count, page_size FROM pragma_page_count(), pragma_page_size()`);
		const [{ count: partialIndexSlices = 0 } = {}] = await this.db.select({ count: sql`count(*)` }).from(partialIndexes);
		return {
			dbSizeBytes: pageCount * pageSize,
			partialIndexSlices
		};
	}
	async diagnostics() {
		await this.init();
		const scalar = async (query) => (await this.db.values(query))[0]?.[0];
		const tables = await this.db.values(sql`SELECT name FROM sqlite_master WHERE type = 'table' AND name NOT LIKE 'sqlite_%' AND name NOT LIKE 'search_fts_%' AND name NOT LIKE 'search_title_trigram_%' ORDER BY name`);
		const rowCounts = {};
		for (const [name] of tables) rowCounts[name] = await scalar(sql`SELECT count(*) FROM ${sql.identifier(name)}`) ?? 0;
		const [[, , file] = []] = await this.db.values(sql`PRAGMA database_list`);
		return {
			sqliteVersion: await scalar(sql`SELECT sqlite_version()`) ?? "",
			file: file || ":memory:",
			bytes: (await scalar(sql`PRAGMA page_count`) ?? 0) * (await scalar(sql`PRAGMA page_size`) ?? 0),
			lastMigration: await scalar(sql`SELECT hash FROM ${sql.identifier("__local_db_migrations")} ORDER BY created_at DESC LIMIT 1`) ?? "",
			rowCounts,
			fullBootstrapPending: this.bootstrapPending
		};
	}
	async withTransaction(_tables, _mode, fn) {
		await this.init();
		return this.run(() => this.localDb.withTransaction(fn));
	}
	async clear(table) {
		const entity = this.entityTable(table);
		await this.run(() => this.db.delete(entity));
	}
	async clearAll() {
		await this.queueMetaWrite(async () => {
			for (const entity of Object.values(LOCAL_DB_TABLES)) await this.db.delete(entity);
			await this.db.delete(meta);
		});
		this.bootstrapPending = false;
	}
	queueMetaWrite(write) {
		const next = this.metaUpdateChain.then(() => this.run(() => this.localDb.withOwnTransaction(write)));
		this.metaUpdateChain = next.catch(() => void 0);
		return next;
	}
	get db() {
		return this.localDb.db;
	}
	entityTable(table) {
		if (table === "_meta") throw new Error("_meta is accessed through getMetaData/updateMetaData");
		return LOCAL_DB_TABLES[table];
	}
	indexedColumn(table, indexName) {
		const column = INDEXED_COLUMNS[table]?.[indexName];
		if (!column) throw new Error(`local-db: ${table}.${indexName} is not indexed`);
		return column;
	}
	toRecords(rows) {
		return deserializeDatesInArray(rows.map((row) => row.data));
	}
	async readMetaRow(id) {
		await this.init();
		return (await this.run(() => this.db.select({ data: meta.data }).from(meta).where(eq(meta.id, id)).limit(1)))[0]?.data;
	}
	async writeMetaRow(id, data) {
		await this.init();
		await this.run(() => this.db.insert(meta).values({
			id,
			data
		}).onConflictDoUpdate({
			target: meta.id,
			set: { data }
		}));
	}
	async run(op) {
		await this.init();
		try {
			return await op();
		} catch (error) {
			throw this.mapError(error);
		}
	}
	mapError(error) {
		if (error instanceof DiskFullError) return error;
		if (errorMatchesAnyPattern(error, DISK_FULL_MESSAGE_PATTERNS)) {
			this.logger.warn("local-db: device storage is full", {
				context: "local_db_disk_full",
				reason: SENTRY_SUPPRESSION_REASONS.deviceStorage
			});
			return new DiskFullError(error);
		}
		return error;
	}
};
/** Models serialise through `toJSON`; plain objects are stored as-is with Dates as ISO strings */
function serializeRecord(record) {
	const toJSON = record.toJSON;
	if (typeof toJSON === "function") return {
		...toJSON.call(record),
		id: record.id
	};
	return JSON.parse(JSON.stringify(record));
}
//#endregion
//#region src/search-adapter.ts
const SEARCH_INDEX_VERSION = 20;
const MAX_QUERY_LENGTH = 1e3;
const WRITE_CHUNK = 200;
const NATIVE_REINDEX_CHUNK = 2e3;
const PREFIX_MIN_LENGTH = 2;
const FUZZY_TRIGGER = SEARCH_PRESENTATION_LIMIT / 10;
const FUZZY_FETCH_LIMIT = 100;
const FUZZY_MIN_COVERAGE = .5;
const TRIGRAM_TYPES = /* @__PURE__ */ new Set([
	"thread",
	"journal",
	"meeting_summary",
	"file"
]);
const CONTENT_WINDOW = 300;
const CONTENT_WINDOW_LEAD = 100;
const EPOCH = "1970-01-01T00:00:00.000Z";
function toFtsMatchQuery(normalized) {
	const tokens = tokenizeForSearchIndex(normalized).map((token) => `"${token.toLowerCase().replaceAll("\"", "")}"`);
	if (tokens.length === 0) return null;
	const last = tokens[tokens.length - 1];
	if (last.length - 2 >= PREFIX_MIN_LENGTH) tokens[tokens.length - 1] = `${last}*`;
	return tokens.join(" ");
}
function queryTrigrams(phraseLower) {
	const text = phraseLower.replaceAll("\"", "");
	const out = /* @__PURE__ */ new Set();
	for (let i = 0; i + 3 <= text.length; i++) out.add(text.slice(i, i + 3));
	return [...out];
}
function trigramCoverage(wanted, title) {
	const have = new Set(queryTrigrams(title.toLowerCase()));
	let hits = 0;
	for (const trigram of wanted) if (have.has(trigram)) hits++;
	return hits / wanted.length;
}
var SqliteSearchAdapter = class extends BaseSearchIndexer {
	storageAdapter;
	excludeTypes;
	constructor(storageAdapter, logger, options) {
		super(storageAdapter, {
			searchIndexVersion: 20,
			chunkSize: 100,
			pageSize: 100,
			sources: buildSources(options.meetingNotesToText)
		}, logger);
		this.storageAdapter = storageAdapter;
		this.excludeTypes = options.excludeTypes ?? [];
	}
	async init() {
		await this.storageAdapter.init();
	}
	async search(query) {
		await this.init();
		const normalized = normalizeSearchQuery(query);
		if (!normalized || normalized.length > MAX_QUERY_LENGTH) return [];
		const match = toFtsMatchQuery(normalized);
		if (!match) return [];
		const phraseLower = normalized.toLowerCase();
		try {
			const exact = (await this.db.values(searchQuery(ftsHits(match, this.excludeTypes), phraseLower))).map(toSearchItem);
			const items = exact.length < FUZZY_TRIGGER ? [...exact, ...await this.fuzzyTitleMatches(phraseLower, exact)] : exact;
			return rankSearchItems(items, normalized).slice(0, SEARCH_PRESENTATION_LIMIT);
		} catch (error) {
			this.logger.error(error, {
				context: "sqlite_search_adapter_search_error",
				metadata: { query: normalized }
			});
			return [];
		}
	}
	async fuzzyTitleMatches(phraseLower, exact) {
		const trigrams = queryTrigrams(phraseLower);
		if (trigrams.length === 0) return [];
		const match = trigrams.map((trigram) => `"${trigram}"`).join(" OR ");
		const rows = await this.db.values(searchQuery(trigramHits(match, this.excludeTypes), phraseLower));
		const seen = new Set(exact.map((item) => item.id));
		return rows.map(toSearchItem).filter((item) => {
			if (seen.has(item.id) || !("title" in item) || !item.title) return false;
			return trigramCoverage(trigrams, item.title) >= FUZZY_MIN_COVERAGE;
		});
	}
	async addItems(items) {
		const rows = (await this.hydrateMessageReportTemplateIds(items)).map(toIndexRow);
		await this.storageAdapter.localDb.withTransaction(async () => {
			for (let i = 0; i < rows.length; i += WRITE_CHUNK) await this.writeRows(rows.slice(i, i + WRITE_CHUNK));
		});
	}
	async removeItems(ids) {
		if (ids.length === 0) return;
		const idList = sqlList(ids);
		await this.deleteIndexRows(idList);
		await this.db.run(sql`DELETE FROM search_note_text WHERE id IN (${idList})`);
	}
	async deleteIndexRows(idList) {
		await this.db.run(sql`DELETE FROM search_fts WHERE rowid IN (SELECT rowid FROM search_docs WHERE id IN (${idList}))`);
		await this.db.run(sql`DELETE FROM search_title_trigram WHERE rowid IN (SELECT rowid FROM search_docs WHERE id IN (${idList}))`);
	}
	async clearIndex() {
		await this.db.run(sql`INSERT INTO search_fts(search_fts) VALUES('delete-all')`);
		await this.db.run(sql`INSERT INTO search_title_trigram(search_title_trigram) VALUES('delete-all')`);
		await this.db.run(sql`DELETE FROM search_docs`);
		await this.db.run(sql`DELETE FROM search_note_text`);
	}
	async indexTableNatively(table) {
		const reindex = NATIVE_REINDEX[table];
		if (!reindex) return false;
		const { localDb } = this.storageAdapter;
		await localDb.withTransaction(async () => {
			for (const statement of clearType(reindex.type)) await this.db.run(statement);
		});
		let after = 0;
		while (true) {
			this.throwIfAborted();
			const [[upTo]] = await this.db.values(sql`SELECT max(rowid) FROM (SELECT rowid FROM ${sql.identifier(table)} WHERE rowid > ${after} ORDER BY rowid LIMIT ${NATIVE_REINDEX_CHUNK})`);
			if (upTo === null) break;
			const range = {
				after,
				upTo
			};
			await localDb.withTransaction(async () => {
				for (const statement of reindex.statements(range)) await this.db.run(statement);
			});
			after = upTo;
			await new Promise((resolve) => setTimeout(resolve, 0));
		}
		return true;
	}
	async onBeforeSourceIndex(source, rows, isFullReindex) {
		if (source.table !== "meetings" || isFullReindex) return;
		const docIds = rows.filter((meeting) => meeting.id).flatMap((meeting) => getMeetingSearchDocIds(meeting.id));
		if (docIds.length > 0) {
			await this.removeItemsInChunks(docIds);
			this.throwIfAborted();
		}
	}
	get logLabel() {
		return "SqliteSearchAdapter";
	}
	get logContext() {
		return "sqlite_search_adapter";
	}
	get db() {
		return this.storageAdapter.localDb.db;
	}
	async writeRows(rows) {
		const ids = rows.map((row) => row.id);
		await this.db.run(sql`INSERT OR IGNORE INTO search_docs(id) VALUES ${sql.join(ids.map((id) => sql`(${id})`), sql`, `)}`);
		await this.deleteIndexRows(sqlList(ids));
		const noteRows = rows.filter((row) => row.type === "meeting_note");
		if (noteRows.length > 0) await this.db.run(sql`INSERT INTO search_note_text(id, text) VALUES ${sql.join(noteRows.map((row) => sql`(${row.id}, ${row.content})`), sql`, `)} ON CONFLICT(id) DO UPDATE SET text = excluded.text`);
		await this.db.run(sql`INSERT INTO search_fts(rowid, id, type, threadId, reportTemplateId, updatedAt, title, content) VALUES ${sql.join(rows.map((row) => sql`((SELECT rowid FROM search_docs WHERE id = ${row.id}), ${row.id}, ${row.type}, ${row.threadId}, ${row.reportTemplateId}, ${row.updatedAt}, ${row.title}, ${row.content})`), sql`, `)}`);
		const titleRows = rows.filter((row) => TRIGRAM_TYPES.has(row.type) && row.title);
		if (titleRows.length > 0) await this.db.run(sql`INSERT INTO search_title_trigram(rowid, id, type, threadId, reportTemplateId, updatedAt, title) VALUES ${sql.join(titleRows.map((row) => sql`((SELECT rowid FROM search_docs WHERE id = ${row.id}), ${row.id}, ${row.type}, ${row.threadId}, ${row.reportTemplateId}, ${row.updatedAt}, ${row.title})`), sql`, `)}`);
	}
	async hydrateMessageReportTemplateIds(items) {
		const threadIds = /* @__PURE__ */ new Set();
		for (const item of items) if (item.type === "message" && item.reportTemplateId === void 0) threadIds.add(item.threadId);
		const threadQueries = this.storage.entities.threads;
		if (threadIds.size === 0 || !threadQueries) return items;
		const threads = await threadQueries.getByIds([...threadIds]);
		const byThread = new Map(threads.filter(isRoutineRunThread).map((thread) => [thread.id, thread.reportTemplateId]));
		return items.map((item) => {
			if (item.type !== "message") return item;
			const reportTemplateId = byThread.get(item.threadId);
			return reportTemplateId === void 0 ? item : {
				...item,
				reportTemplateId
			};
		});
	}
};
function sqlList(values) {
	return sql.join(values.map((value) => sql`${value}`), sql`, `);
}
function toIndexRow(item) {
	const row = item;
	return {
		id: row.id,
		type: row.type,
		threadId: row.threadId ?? null,
		reportTemplateId: row.reportTemplateId ?? null,
		updatedAt: row.updatedAt ?? EPOCH,
		title: row.title ?? "",
		content: row.content ?? ""
	};
}
function toSearchItem([id, type, threadId, reportTemplateId, updatedAt, title, content, contentType]) {
	return {
		id,
		type,
		threadId: threadId ?? void 0,
		reportTemplateId: reportTemplateId ?? void 0,
		title: title ?? void 0,
		content: content ?? void 0,
		contentType: type === "file" ? contentType ?? void 0 : void 0,
		updatedAt: updatedAt ?? EPOCH
	};
}
function ftsHits(match, excludeTypes) {
	return sql`
    SELECT rowid, id, type, threadId, reportTemplateId, updatedAt
    FROM search_fts
    WHERE search_fts MATCH ${match}${notInTypes(excludeTypes)}
    ORDER BY rank, updatedAt DESC
    LIMIT ${SEARCH_FETCH_LIMIT}`;
}
function trigramHits(match, excludeTypes) {
	return sql`
    SELECT rowid, id, type, threadId, reportTemplateId, updatedAt
    FROM search_title_trigram
    WHERE search_title_trigram MATCH ${match}${notInTypes(excludeTypes)}
    ORDER BY rank, updatedAt DESC
    LIMIT ${FUZZY_FETCH_LIMIT}`;
}
/** Excluding in SQL keeps the fetch limit available to the remaining types */
function notInTypes(excludeTypes) {
	return excludeTypes.length === 0 ? sql`` : sql` AND type NOT IN (${sqlList(excludeTypes)})`;
}
function searchQuery(hits, phraseLower) {
	return sql`
    WITH hits AS (${hits}),
    texts AS MATERIALIZED (
      SELECT f.id, f.type, f.threadId, f.reportTemplateId, f.updatedAt,
        CASE f.type
          WHEN 'thread' THEN json_extract(t.data, '$.title')
          WHEN 'journal' THEN json_extract(j.data, '$.sections.title')
          WHEN 'file' THEN json_extract(fi.data, '$.filename')
          WHEN 'message' THEN NULL
          ELSE json_extract(mt.data, '$.name')
        END AS title,
        CASE f.type
          WHEN 'message' THEN json_extract(m.data, '$.content')
          WHEN 'journal' THEN json_extract(j.data, '$.text')
          WHEN 'meeting_summary' THEN json_extract(mt.data, '$.summary')
          WHEN 'meeting_note' THEN n.text
          ELSE NULL
        END AS content,
        CASE f.type WHEN 'file' THEN json_extract(fi.data, '$.contentType') END AS contentType
      FROM hits f
      LEFT JOIN threads t ON f.type = 'thread' AND t.id = f.id
      LEFT JOIN messages m ON f.type = 'message' AND m.id = f.id
      LEFT JOIN journals j ON f.type = 'journal' AND j.id = f.id
      LEFT JOIN meetings mt ON f.type IN ('meeting_summary', 'meeting_note')
        AND mt.id = substr(f.id, 1, instr(f.id, ':') - 1)
      LEFT JOIN search_note_text n ON f.type = 'meeting_note' AND n.id = f.id
      LEFT JOIN files fi ON f.type = 'file' AND fi.id = f.id
    ),
    located AS MATERIALIZED (
      SELECT *, instr(lower(content), ${phraseLower}) AS pos FROM texts
    )
    SELECT id, type, threadId, reportTemplateId, updatedAt, title,
      CASE
        WHEN content IS NULL THEN NULL
        WHEN pos > ${CONTENT_WINDOW_LEAD}
          THEN '…' || substr(content, pos - ${CONTENT_WINDOW_LEAD}, ${CONTENT_WINDOW})
        ELSE substr(content, 1, ${CONTENT_WINDOW})
      END AS content,
      contentType
    FROM located
  `;
}
/** A resume replays a table whose chunks committed before its checkpoint landed */
function clearType(type) {
	return [sql`DELETE FROM search_fts WHERE type = ${type}`, sql`DELETE FROM search_title_trigram WHERE type = ${type}`];
}
function inRange(alias, { after, upTo }) {
	const rowid = sql.raw(`${alias}.rowid`);
	return sql`${rowid} > ${after} AND ${rowid} <= ${upTo}`;
}
const NATIVE_REINDEX = {
	threads: {
		type: "thread",
		statements: (range) => [
			sql`INSERT OR IGNORE INTO search_docs(id)
          SELECT t.id FROM threads t WHERE ${inRange("t", range)} AND t.deleted_at IS NULL AND coalesce(json_extract(t.data, '$.title'), '') != ''`,
			sql`INSERT OR REPLACE INTO search_fts(rowid, id, type, threadId, reportTemplateId, updatedAt, title, content)
          SELECT d.rowid, t.id, 'thread', NULL, t.report_template_id, coalesce(t.updated_at, ${EPOCH}), json_extract(t.data, '$.title'), ''
          FROM threads t JOIN search_docs d ON d.id = t.id
          WHERE ${inRange("t", range)} AND t.deleted_at IS NULL AND coalesce(json_extract(t.data, '$.title'), '') != ''`,
			sql`INSERT OR REPLACE INTO search_title_trigram(rowid, id, type, threadId, reportTemplateId, updatedAt, title)
          SELECT d.rowid, t.id, 'thread', NULL, t.report_template_id, coalesce(t.updated_at, ${EPOCH}), json_extract(t.data, '$.title')
          FROM threads t JOIN search_docs d ON d.id = t.id
          WHERE ${inRange("t", range)} AND t.deleted_at IS NULL AND coalesce(json_extract(t.data, '$.title'), '') != ''`
		]
	},
	messages: {
		type: "message",
		statements: (range) => [sql`INSERT OR IGNORE INTO search_docs(id)
          SELECT m.id FROM messages m WHERE ${inRange("m", range)} AND m.deleted_at IS NULL AND m.thread_id IS NOT NULL AND coalesce(json_extract(m.data, '$.content'), '') != ''`, sql`INSERT OR REPLACE INTO search_fts(rowid, id, type, threadId, reportTemplateId, updatedAt, title, content)
          SELECT d.rowid, m.id, 'message', m.thread_id, th.report_template_id, coalesce(m.updated_at, ${EPOCH}), '', json_extract(m.data, '$.content')
          FROM messages m JOIN search_docs d ON d.id = m.id LEFT JOIN threads th ON th.id = m.thread_id
          WHERE ${inRange("m", range)} AND m.deleted_at IS NULL AND m.thread_id IS NOT NULL AND coalesce(json_extract(m.data, '$.content'), '') != ''`]
	},
	journals: {
		type: "journal",
		statements: (range) => [
			sql`INSERT OR IGNORE INTO search_docs(id) SELECT j.id FROM journals j WHERE ${inRange("j", range)} AND j.deleted_at IS NULL`,
			sql`INSERT OR REPLACE INTO search_fts(rowid, id, type, threadId, reportTemplateId, updatedAt, title, content)
          SELECT d.rowid, j.id, 'journal', NULL, NULL, coalesce(j.updated_at, ${EPOCH}), coalesce(json_extract(j.data, '$.sections.title'), ''), coalesce(json_extract(j.data, '$.text'), '')
          FROM journals j JOIN search_docs d ON d.id = j.id WHERE ${inRange("j", range)} AND j.deleted_at IS NULL`,
			sql`INSERT OR REPLACE INTO search_title_trigram(rowid, id, type, threadId, reportTemplateId, updatedAt, title)
          SELECT d.rowid, j.id, 'journal', NULL, NULL, coalesce(j.updated_at, ${EPOCH}), json_extract(j.data, '$.sections.title')
          FROM journals j JOIN search_docs d ON d.id = j.id
          WHERE ${inRange("j", range)} AND j.deleted_at IS NULL AND coalesce(json_extract(j.data, '$.sections.title'), '') != ''`
		]
	},
	files: {
		type: "file",
		statements: (range) => [
			sql`INSERT OR IGNORE INTO search_docs(id)
          SELECT fi.id FROM files fi WHERE ${inRange("fi", range)} AND fi.deleted_at IS NULL AND coalesce(json_extract(fi.data, '$.filename'), '') != ''`,
			sql`INSERT OR REPLACE INTO search_fts(rowid, id, type, threadId, reportTemplateId, updatedAt, title, content)
          SELECT d.rowid, fi.id, 'file', NULL, NULL, coalesce(fi.updated_at, ${EPOCH}), json_extract(fi.data, '$.filename'), ''
          FROM files fi JOIN search_docs d ON d.id = fi.id
          WHERE ${inRange("fi", range)} AND fi.deleted_at IS NULL AND coalesce(json_extract(fi.data, '$.filename'), '') != ''`,
			sql`INSERT OR REPLACE INTO search_title_trigram(rowid, id, type, threadId, reportTemplateId, updatedAt, title)
          SELECT d.rowid, fi.id, 'file', NULL, NULL, coalesce(fi.updated_at, ${EPOCH}), json_extract(fi.data, '$.filename')
          FROM files fi JOIN search_docs d ON d.id = fi.id
          WHERE ${inRange("fi", range)} AND fi.deleted_at IS NULL AND coalesce(json_extract(fi.data, '$.filename'), '') != ''`
		]
	}
};
function buildSources(meetingNotesToText) {
	return [
		defineIndexableSource("threads", (rows) => buildThreadItems(rows, { requireTitle: true }), { rowIdIsDocId: true }),
		defineIndexableSource("messages", (rows) => buildMessageItems(rows, { requireContent: true }), { rowIdIsDocId: true }),
		defineIndexableSource("journals", (rows) => buildJournalItems(rows), { rowIdIsDocId: true }),
		defineIndexableSource("meetings", (rows) => buildMeetingItems(rows, { notesToText: meetingNotesToText })),
		defineIndexableSource("files", (rows) => buildFileItems(rows), { rowIdIsDocId: true })
	];
}
//#endregion
export { DiskFullError, LOCAL_DB_TABLES, MIGRATIONS_TABLE, SEARCH_INDEX_VERSION, SqliteSearchAdapter, SqliteStorageAdapter, createEntityQueryModules, createExecutorServer, deserializeDates, deserializeDatesInArray, normalizeParams, openLocalDb, queryTrigrams, schema_exports as schema, serializeRecord, toFtsMatchQuery };

//# sourceMappingURL=index.js.map